import React, { useState } from 'react';

import { Box, Tab, Tabs } from '@mui/material';

import LoyaltyClaimCampaignsPage from '../LoyaltyClaimCampaignsPage';
import LoyaltyPayloadBuilderPage from '../LoyaltyPayloadBuilderPage';
import LoyaltyPromoCampaignsPage from '../LoyaltyPromoCampaignsPage';
import LoyaltyUserClaimsPage from '../LoyaltyUserClaimsPage';
import { loyaltySubTabsContainerSx } from '../loyaltyTabStyles';

type CampaignsSubTab = 'promo' | 'claim' | 'payload-builder' | 'redemptions';

/**
 * Campaigns page: groups every campaign-related workflow under a single
 * top-level loyalty tab to reduce nav width.
 */
export default function CampaignsPage() {
  const [tab, setTab] = useState<CampaignsSubTab>('promo');

  return (
    <Box>
      <Box sx={loyaltySubTabsContainerSx}>
        <Tabs value={tab} onChange={(_, next) => setTab(next as CampaignsSubTab)}>
          <Tab value="promo" label="Promo Campaigns" />
          <Tab value="claim" label="Claim Campaigns" />
          <Tab value="payload-builder" label="Payload Builder" />
          <Tab value="redemptions" label="Process Campaign Redemptions" />
        </Tabs>
      </Box>

      {tab === 'promo' && <LoyaltyPromoCampaignsPage />}
      {tab === 'claim' && <LoyaltyClaimCampaignsPage />}
      {tab === 'payload-builder' && <LoyaltyPayloadBuilderPage />}
      {tab === 'redemptions' && <LoyaltyUserClaimsPage />}
    </Box>
  );
}
